/**
 * Created by rickborst on 01/03/2017.
 */
import _ from 'lodash';
import {
    convertFromGetActiveUser,
    convertForUpdateUser,
    convertForRegisterUser,
    convertForEntitlements,
    convertForSubscriptions,
    convertForPaymentMethod,
    convertFromEntitlements,
    convertFromSubscriptions,
    convertFromPaymentMethod,
    convertForChangePassword,
    convertFromPaymentDetails,
    convertForCreateHousehold
} from '../adapters/users';
import {isValidResponse} from '../validators/users';

import User from 'models/user';
import PaymentDetails from 'models/paymentdetails';

/**
 * Returns the current active user (based on the session).
 *
 * @returns {Promise} Active user promise.
 */
function getActiveUser () {
    let url = this._baseUrl + this._endPoints.getActiveUser;

    return this.read(
        {
            url: url
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            let data = convertFromGetActiveUser.call(this, response);

            return new User(data);
        });
}

/**
 * Updates the current user by passing a User instance to the api.
 *
 * @param {Object} user - User instance.
 * @returns {Promise} Update user promise.
 */
function updateUser (user) {
    let url = this._baseUrl + this._endPoints.updateUser,
        data = convertForUpdateUser.call(this, user);

    data.user.username = user.email;
    return this.update(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            let userData = convertFromGetActiveUser.call(this, response);

            return new User(userData);
        });
}

/**
 * Registers user by passing users information to API.
 *
 * @param {Object} registrationFormData - Data from registration form.
 * @returns {Promise} Update user promise.
 */
function registerUser (registrationFormData) {
    let url = this._baseUrl + this._endPoints.registerUser,
        data = convertForRegisterUser.call(this, registrationFormData);

    return this.create(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            let userData = convertFromGetActiveUser.call(this, response);

            return new User(userData);
        });
}

/**
 * Retrieves any entitlements on the account.
 *
 * @returns {Promise} Entitlements promise.
 */
function getEntitlements () {
    let url = this._baseUrl + this._endPoints.entitlements,
        data = convertForEntitlements.call(this);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {

            return convertFromEntitlements.call(this, response);
        });
}

/**
 * Retrieves any subscriptions on the account.
 *
 * @param {Object} entitlement - Entitlement object.
 * @returns {Promise} Subscriptions promise.
 */
function getSubscriptions (entitlement) {
    let url = this._baseUrl + this._endPoints.subscriptions,
        data = convertForSubscriptions.call(this, entitlement);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {
            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            return convertFromSubscriptions.call(this, response);
        })
        .catch((err)=> {
        //   throw err
        console.log(err)
        });
}

/**
 * Retrieves any payment method on the active subscription.
 *
 * @returns {Promise} Payment method promise.
 */
function getPaymentMethod () {
    let url = this._baseUrl + this._endPoints.paymentMethods,
        data = convertForPaymentMethod.call(this);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {

            return convertFromPaymentMethod.call(this, response);
        });
}

/**
 * Retrieves all payment details for the current account.
 *
 * @returns {Promise} Payment details promise.
 */
function getPaymentDetails () {
    let responses = [];

    return getEntitlements.call(this)
        .then(data => {

            let entitlementID = _.get(data, ['apiSpecifics', 'entitlementId']);

            responses.push(data);

            return Promise.all([
                getSubscriptions.call(this, entitlementID),
                getPaymentMethod.call(this)
            ]);
        })
        .then(results => {
            let data;

            responses = [
                ...responses,
                ...results
            ];

            data = convertFromPaymentDetails.call(this, responses);

            return new PaymentDetails(data);
        });
}

/**
 * Changes users password.
 *
 * @param {Object} payloadData - Data for request payload.
 * @returns {Promise} Payment method promise.
 */
function changePassword (payloadData) {
    let url = this._baseUrl + this._endPoints.changePassword,
        data = convertForChangePassword(payloadData);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {

            return convertFromGetActiveUser.call(this, response);
        });
}

/**
 * Creates household for newly created user.
 *
 * @param {Object} householdData - Data for request payload.
 * @returns {Promise} Payment method promise.
 */
function createHousehold (householdData) {
    let url = this._baseUrl + this._endPoints.addHousehold,
        data = convertForCreateHousehold(householdData);

    if (!data.household.name || !data.household.externalId || !data.household.description) {
        return Promise.reject();
    }
    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {
            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return Promise.resolve(response);
        })
        .then(response => {

            return Promise.resolve(response);
        });
}


export {
    getActiveUser,
    updateUser,
    registerUser,
    getEntitlements,
    getSubscriptions,
    getPaymentMethod,
    getPaymentDetails,
    changePassword,
    createHousehold
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/users.js